const CrawlLinkedIn = () => {
    return (
        <div className="card pb-2.5">
            <div className="card-header" id="crawl_linkedin">
                <h3 className="card-title">LinkedIn</h3>
            </div>
            <div className="card-body grid gap-5">
                <div className="flex flex-col items-center text-center">
                    <span className="mt-4 text-lg">
                        LinkedIn integration is coming soon!
                    </span>
                    <p className="text-sm text-gray-500 mt-2">
                        Stay tuned for updates – we're making it even easier to add jobs directly from LinkedIn!
                    </p>
                </div>
            </div>
        </div>
    );
};

export { CrawlLinkedIn };
